export { DispensariesSortController as DispensariesSort } from './dispensaries-sort-controller';
